import "@/App.css";
import Navbar from "@/components/Navbar";
import Hero from "@/components/sections/Hero";
import Novela from "@/components/sections/Novela";
import Pelicula from "@/components/sections/Pelicula";
import Proyecto from "@/components/sections/Proyecto";
import Contribuir from "@/components/sections/Contribuir";
import Nosotras from "@/components/sections/Nosotras";
import NGFilms from "@/components/sections/NGFilms";
import Footer from "@/components/sections/Footer";

function App() {
  return (
    <div className="App bg-[#F2EDE3] text-[#141414]" data-testid="landing-root">
      <Navbar />
      <main>
        <Hero />
        <Novela />
        <Pelicula />
        <Proyecto />
        <Contribuir />
        <Nosotras />
        <NGFilms />
      </main>
      <Footer />
    </div>
  );
}

export default App;
